import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import ConsultasPacientes from './ConsultasPacientes';

const PanelMedico = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom align="center" color="primary">
        Panel Médico
      </Typography>
      <Box sx={{ mt: 4 }}>
        <ConsultasPacientes />
      </Box>
    </Container>
  );
};

export default PanelMedico; 